/** 模型库接口成功码：平台标准 0 + 旧 mall 200 */
export function isModelApiOk(res: { code?: number } | null | undefined): boolean {
  return res?.code === 0 || res?.code === 200
}

/**
 * 取出业务载荷。
 * - 新：{ code:0, data }
 * - 旧：{ code:200, result }
 */
export function unwrapModelPayload<T>(res: { code?: number; data?: T; result?: T } | null | undefined): T | undefined {
  if (!isModelApiOk(res)) return undefined
  return (res?.data ?? res?.result) as T | undefined
}
